module.exports = "<!DOCTYPE html>\r\n<html>\r\n\r\n<head>\r\n  <meta charset=\"utf-8\">\r\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\r\n  <title>{{files.0.name}}</title>\r\n  <link rel=\"stylesheet\" href=\"https://stackedit.io/style.css\" />\r\n</head>\r\n\r\n{{#if pdf}}\r\n<body class=\"stackedit stackedit--pdf\">\r\n{{else}}\r\n<body class=\"stackedit\">\r\n{{/if}}\r\n  <div class=\"stackedit__html\">{{{files.0.content.html}}}</div>\r\n</body>\r\n\r\n</html>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/templates/styledHtmlTemplate.html
// module id = 1601
// module chunks = 1